import React, { useState, useEffect, useMemo, ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Template from '../../components/Template';
import Alert from '../../helpers/Alert';
import copy from 'clipboard-copy';
import { FaCopy, FaRegCopy } from 'react-icons/fa'
import ModalVisualization from '../../components/ModalVisualization';
import logoEmpty from '../../assets/images/relato-logo-empty.png';
import docPDF from './pdf'
import './index.css'
// SERVICES
import { getOsById } from '../../services/OsService';
import { getAllFileByOs, compararOrdemArquivo } from "../../services/FileService";

export default function Relato(props: any) {
  let history = useNavigate();

  const [data, setData] = useState<any>();
  const [logo, setLogo] = useState<File>();
  const [titles, setTitles] = useState<any>({
    registro: 'Registro',
    entrevista: 'Entrevistas',
    relatoCroqui: 'Pesquisa local/croqui',
    relatoOrgaos: 'Órgãos Públicos',
    segConvivioComercialRel: 'Entrevista com o Segurado',
    segConvivioResidencialRel: 'Entrevista com Envolvido',
    terConvivioComercialRel: 'Entrevista com o Terceiro',
    terConvivioResidencialRel: 'Entrevista com Envolvido (terceiro)',
    transcricaoEntrevista: 'Transcrição da Entrevista',
    redesSociais: 'Redes Sociais',
    conclusao: 'Conclusão',
  });
  const [includes, setIncludes] = useState<any>({
    registro: true,
    entrevista: true,
    relatoCroqui: true,
    relatoOrgaos: true,
    segConvivioComercialRel: true,
    segConvivioResidencialRel: true,
    terConvivioComercialRel: true,
    terConvivioResidencialRel: true,
    transcricaoEntrevista: true,
    redesSociais: true,
    conclusao: true,
  });
  const [photos, setPhotos] = useState<any[]>([]);
  const [exporting, setExporting] = useState<boolean>(false);
  const createdAt = useMemo(() => `${new Date(data?.createdAt)?.getFullYear()}`, [data]);

  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          // Restante do código...
          const orderServiceResponse = await getOsById(id);
          setData(orderServiceResponse.data);

          getAllFileByOs(id).then((res: any) => {

            const newData = res.data.map((i: any) => {
              return {
                ...i,
                url: `${process.env.REACT_APP_API_URL}${i.url}`,
              }
            })
            setPhotos(newData);
          })
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        // Redireciona para a lista de ordens de serviço em caso de erro
        history("/lista-os");
      }
    };

    // Chama a função fetchData
    fetchData();
  }, [id]);

  /** Mesmo botão nas duas pontas do relato — um só comportamento. */
  const BotaoExportar = () => (
    <button
      className='btn btn-sm bg-primary w-25'
      disabled={exporting}
      onClick={async () => {
        try {
          setExporting(true);
          await docPDF(data, titles, logo, includes, photos);
          Alert(true, 'PDF exportado com sucesso!');
        } catch (error) {
          console.error('Erro exportando PDF:', error);
          Alert(false, 'Falha ao exportar PDF. Verifique o console para mais detalhes.');
        } finally {
          setExporting(false);
        }
      }}>
      {exporting ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Gerando PDF...
        </>
      ) : 'Exportar PDF'}
    </button>
  );

  return (
    <Template path={'Nova O.S.'}>
      <div className='p-4'>
        <div className='row'>
          <h3>Relatório de sindicância <div className="badge bg-secundary" >{data?.sinistro}/{createdAt}</div></h3>
        </div>        <hr />

        <div className="row">
          <h4>Configurações</h4>
          <div className='d-flex'>
            <img src={logo ? URL.createObjectURL(logo) : logoEmpty} width='200px' />
            <div className='ms-4'>
              <h5>Adicionar logo</h5>
              <p>Escolha uma imagem para aparecer no relatorio</p>
              <label htmlFor="fileInput" className="btn btn-sm btn-secundary">
                Escolher arquivo
                <input
                  type="file"
                  name="fileInput"
                  accept="image/*"
                  onChange={(event: any) => { setLogo(event.target.files[0]) }}
                  id="fileInput"
                  style={{ display: "none" }}
                  multiple={false}
                />
              </label>
            </div>

          </div>
        </div>

        {/*
          Exportar aparece no topo E no fim. O relato é longo, e antes era
          preciso rolar tudo para chegar ao único botão — inclusive quando a
          pessoa só queria reexportar depois de um ajuste pequeno.
        */}
        <div className='d-flex justify-content-end mb-3'>
          <BotaoExportar />
        </div>

        <SectionOS
          title={titles}
          setTitle={setTitles}
          includes={includes}
          setIncludes={setIncludes}
          text={data?.registro_observacao}
          photos={photos}
          sectionKey={'registro'}
          fileKey={'registro'}
        >
          <p><strong>Seguradora</strong>: {data?.seguradora}</p>
          <p><strong>Sinistro</strong>: {data?.sinistro}</p>
          <p><strong>Segurado</strong> {data?.segurado}</p>
          <p><strong>Natureza</strong>: {data?.natureza}</p>
          <p><strong>Local</strong>: {data?.endereco}</p>
          <p><strong>Veículo</strong>: {data?.veiculo}</p>
          <p><strong>Placa</strong>: {data?.placa}</p>
          <p><strong>Progresso</strong>: {data?.valorProgresso.toFixed(2) + "%"}</p>
          <p><strong>Regularidade</strong>: {data?.regularidade}</p>
          {/* Caracteriza a O.S., não a entrevista — a tela espelha o PDF. */}
          {data?.tipoSindicancia && <p><strong>Tipo de sindicância</strong>: {data?.tipoSindicancia}</p>}
        </SectionOS>
        <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.relatoCroqui} sectionKey={'relatoCroqui'} fileKey={'croqui'} />
        <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.relatoOrgaos} sectionKey={'relatoOrgaos'} fileKey={'orgaos-publicos'} />
        <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={''} sectionKey={'entrevista'} fileKey={'entrevista'}>
          {data?.profissaoSegurado && <p><strong>Profissão do segurado</strong>: {data?.profissaoSegurado}</p>}
          {data?.localPernoite && <p><strong>Local do pernoite</strong>: {data?.localPernoite}</p>}
          {data?.unicoCondutor && <p><strong>Segurado é único condutor</strong>: {data?.unicoCondutor}</p>}
          {data?.residIdade && <p><strong>Residência possui pessoas entre 18 e 25 anos</strong>: {data?.residIdade}</p>}
          {data?.residIdadeVeiculo && <p><strong>Residência possui pessoas entre 18 e 25 anos que utilizam o veículo</strong>: {data?.residIdadeVeiculo}</p>}
          {data?.condutorPrincipal && <p><strong>Condutor principal</strong>: {data?.condutorPrincipal}</p>}
          {data?.possuiCadastroAplicativo && <p><strong>CPF do condutor cadastrado em aplicativo</strong>: {data?.possuiCadastroAplicativo}</p>}
          {data?.cadastroAplicativo && <p><strong>Segurado é motorista de aplicativo</strong>: {data?.cadastroAplicativo}</p>}
          {data?.haviaPassageiro && <p><strong>No dia do evento estava com passageiros no veículo</strong>: {data?.haviaPassageiro}</p>}
          {data?.endossoParticularComercial && <p><strong>Houve endosso de uso particular para comercial</strong>: {data?.endossoParticularComercial}</p>}
          {data?.endossoAntesDepois && <p><strong>Evento antes ou depois do endosso</strong>: {data?.endossoAntesDepois}</p>}
          {data?.extratoCorrida && <p><strong>Extrato das corridas corresponde ao período de vigência da apólice</strong>: {data?.extratoCorrida}</p>}
          {data?.mediaKmDiaSemana && <p><strong>Média de Km rodado por dia/semana</strong>: {data?.mediaKmDiaSemana}</p>}
          {data?.kmAtual && <p><strong>Quilometragem atual do veículo</strong>: {data?.kmAtual}</p>}
          <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.segConvivioComercialRel} sectionKey={'segConvivioComercialRel'} />
          <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.segConvivioResidencialRel} sectionKey={'segConvivioResidencialRel'} />
          <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.terConvivioComercialRel} sectionKey={'terConvivioComercialRel'} />
          <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.terConvivioResidencialRel} sectionKey={'terConvivioResidencialRel'} />
          <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.transcricaoEntrevista} sectionKey={'transcricaoEntrevista'} />
        </SectionOS>
        <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.redesSociais?.relato} sectionKey={'redesSociais'} fileKey={'redes-sociais'} />
        <SectionOS title={titles} setTitle={setTitles} includes={includes} setIncludes={setIncludes} photos={photos} text={data?.conclusao} sectionKey={'conclusao'} fileKey={'conclusao'}>
          {/* A causa era preenchida na etapa de Conclusão e não aparecia no
              relato nem no PDF — ficava só no banco. Entra aqui, formatada,
              logo antes do texto da conclusão. */}
          {data?.causa && (
            <div className="mb-2">
              <strong>Causa:</strong>
              <div dangerouslySetInnerHTML={{ __html: (data.causa || '').toString() }} />
            </div>
          )}
        </SectionOS>

        <div className='d-flex justify-content-end'>
          <BotaoExportar />
        </div>

        {exporting && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', zIndex: 1050 }}
          >
            <div className="bg-white rounded p-4 d-flex flex-column align-items-center shadow">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
              <span>Gerando PDF, aguarde...</span>
            </div>
          </div>
        )}
      </div>
    </Template>
  )
}

interface propsSectionOS {
  title: any;
  setTitle: Function;
  includes: any;
  setIncludes: Function;
  text?: string;
  photos?: any;
  sectionKey: string;
  fileKey?: string;
  children?: ReactNode;
}
export const SectionOS = ({ title, setTitle, includes, setIncludes, text, photos, sectionKey, fileKey, children }: propsSectionOS) => {

  const handleCopyClick = () => {
    if (text) {
      copy(stripHtmlTags(text));
      Alert(true, 'Texto copiado com sucesso!')
    }
  };
  const stripHtmlTags = (htmlString: string) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || "";
  };

  return (
    <div className="card mt-4">

      {/*HEADER*/}
      <div className="card-header pt-2 d-flex justify-content-between align-items-center">
        <div className="col-md-8">
          <input
            onChange={({ target }) => setTitle({ ...title, [sectionKey]: target.value })}
            type="text"
            className={'form-control input-title'}
            value={title[sectionKey]}
            name={sectionKey}
            id={sectionKey}
            maxLength={80}
          /><small className="text-muted">Clique no título para editar</small>
        </div>
        <div className='d-flex align-items-center'>
          <input
            type="checkbox"
            name={sectionKey}
            id={sectionKey}
            checked={includes[sectionKey]}
            onChange={({ target }) => setIncludes({ ...includes, [sectionKey]: target.checked })}
          />
          <span className='ms-2'>Incluir na exportação</span>
        </div>
      </div>

      {/*BODY*/}
      <div className="card-body">
        {/*CONTEUDO PERSONALIZADO DA SESSAO PASSADO COM CHILDREN */}
        <div>
          {children}
        </div>
        {/*AQUI FICA O RELATO / TEXTO DA SESSÃO */
          text && <div className="mt-2">
            <div className='d-flex justify-content-end m-1'>Copiar <FaCopy className='link' onClick={handleCopyClick} /></div>
            <p dangerouslySetInnerHTML={{ __html: (text || "Não consta").toString() }}></p>
          </div>
        }
        {/*IMAGENS DA SESSÃO */
          fileKey && <div className="mt-2">
            <SectionPhotosOs photos={photos} fileKey={fileKey} imagesPerRow={1} />
          </div>
        }
        {/*ANEXOS DA SESSÃO */
          fileKey && <div className="mt-2">
            <SectionFilesOs photos={photos} fileKey={fileKey} />
          </div>
        }
      </div>
    </div>
  )
}

interface propsSectionPhotosOs {
  photos?: any;
  fileKey?: string;
  imagesPerRow: number;
}
export const SectionPhotosOs = ({ photos, imagesPerRow, fileKey }: propsSectionPhotosOs) => {
  const filteredPhotos = photos
    ?.filter((i: any) => i.etapa === fileKey)
    .filter((i: any) => ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp'].some((ext) => i.url.toLowerCase().includes(ext)))
    // Ordem = a sequência escolhida pelo sindicante (campo `ordem`), com
    // `createdAt` como critério para arquivos anteriores a esse campo. Antes era
    // `updatedAt`, que é reescrito a cada gravação: bastava corrigir a legenda de
    // uma imagem para ela pular de posição no relatório.
    .sort(compararOrdemArquivo);

  const calculateColumnWidth = () => {
    const totalImages = filteredPhotos.length;
    const colWidth = Math.floor(12 / imagesPerRow); // Assuming a 12-column grid system
    return colWidth;
  };

  return (
    <div className="mt-2">
      <div className="row">
        {filteredPhotos.map((item: any, index: any) => (
          <div key={index} className={`col-md-${calculateColumnWidth()}`}>
            <img src={`${item.url}`} width={'100%'} alt={item.label} />
            <p>{`${item.label}`}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

interface propsSectionFilesOs {
  photos?: any;
  fileKey?: string;
}
export const SectionFilesOs = ({ photos, fileKey }: propsSectionFilesOs) => {
  const filteredPhotos = photos
    ?.filter((i: any) => i.etapa === fileKey)
    .filter((i: any) => ['pdf'].some((ext) => i.url.toLowerCase().includes(ext)))
    // Ordem = a sequência escolhida pelo sindicante (campo `ordem`), com
    // `createdAt` como critério para arquivos anteriores a esse campo. Antes era
    // `updatedAt`, que é reescrito a cada gravação: bastava corrigir a legenda de
    // uma imagem para ela pular de posição no relatório.
    .sort(compararOrdemArquivo);

  return (
    filteredPhotos && filteredPhotos.length > 0 &&
    <div className="mt-2">
      <h5>Anexos</h5>
      <div className='row'>
        {filteredPhotos.map((item: any, index: any) => (
          <div key={index} className="col-md-6" >
            <div className="badge bg-secundary p-2 mt-2 w-100">
              <ModalVisualization arquivo={item} />{`${item.nome}`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};